import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { useParams } from 'react-router-dom'

import { IMagazine } from 'src/@interfaces'
import { getConfig } from 'src/helpers'
import { Api, queryConfig, QUERY_DATA } from 'src/service'

import { useUf } from '../useUf'
import { useReseller } from '../useReseller'
import { useCatalogVariation } from '../useCatalogVariation'

const config = getConfig()

export const useMagazine = () => {
  const { reseller: catalogSlug, region } = useParams()
  const catalogVariation = useCatalogVariation()

  const { data: reseller, isGenericUser } = useReseller()

  const uf = useUf()

  const state = useMemo(() => {
    if (region != null) {
      return undefined
    }
    if (isGenericUser && uf) {
      return uf
    }
    return reseller?.addressHomeState
  }, [isGenericUser, region, reseller?.addressHomeState, uf])

  const params: any = {
    business_unit: config.businessUnit,
    is_reseller: false,
    region,
  }

  if (isGenericUser) {
    params['state'] = state
  } else {
    params['catalog_slug'] = catalogSlug
  }

  const getMagazine = async () => {
    const catalogVariant = await catalogVariation.getCatalogVariant()
    params['variant'] = catalogVariant
    return Api.get('/magazine/', {
      params,
    }).then((response) => response.data)
  }

  return useQuery<IMagazine>([QUERY_DATA.MAGAZINE, catalogSlug], getMagazine, queryConfig)
}
